import {
    ComponentProps as DataTableComponentProps
} from '~/frontend/src/components/base/DataTable';


export default {
    hydrate( inboundState : DataTableComponentProps ) : DataTableComponentProps {
        const retVal = {
            ...inboundState
        };

        delete retVal.actionColumns;
        delete retVal.columnDefaults;
        delete retVal.columnDefinitions;
        delete retVal.doSearch;
        delete retVal.dataStructure;
        delete retVal.selection;

        return retVal;
    },

    rehydrate( outboundState : DataTableComponentProps ) : DataTableComponentProps {
        return outboundState;
    }
};
